import {useQuery} from '@tanstack/react-query';
import {contactNotesQueryOptions} from 'queries';

export const usePlaceOfServiceCatalog = (dateOfService: string) =>
  useQuery({
    ...contactNotesQueryOptions.placesOfService(dateOfService),
    enabled: !!dateOfService,
  });
